import React from 'react';

export default function KeyIcon({
    size = 18,
    color = '#596470',
    strokeWidth = 1,
    ...props
}) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M5.48191 12.5499L7.01555 14.0835M9.01553 12.0902L5.87489 15.2242C5.64818 15.4576 5.20142 15.5976 4.88135 15.551L3.42772 15.3509C2.94763 15.2842 2.50087 14.8308 2.42752 14.3507L2.22748 12.8971C2.1808 12.577 2.33417 12.1303 2.55421 11.9035L5.68819 8.76957C5.15474 7.03588 5.56816 5.06881 6.94178 3.70186C8.90884 1.7348 12.1028 1.7348 14.0766 3.70186C16.0503 5.66893 16.0503 8.87625 14.0832 10.8433C12.7096 12.2103 10.7426 12.6304 9.01553 12.0902ZM10.5559 8.22258C10.0035 8.22258 9.55565 7.77477 9.55565 7.22237C9.55565 6.66998 10.0035 6.22217 10.5559 6.22217C11.1083 6.22217 11.5561 6.66998 11.5561 7.22237C11.5561 7.77477 11.1083 8.22258 10.5559 8.22258Z"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
